import styled from 'styled-components';
import tw, { css } from 'twin.macro';
import { Body } from '../../styled components/Typography';
import { TimesheetEntryItemCard } from '../TimesheetEntryItem/TimesheetEntryItem.style';

export const TimesheetUnavailabilitiesCard = styled(TimesheetEntryItemCard)(() => [
  css`
    &:before {
      ${tw`bg-red-base`}
    }
  `
]);
export const TimesheetUnavailabilityItemCardInfo = styled.div(() => [
  tw`flex justify-between gap-16`
]);
export const TimesheetUnavailabilityTitle = styled(Body).attrs(() => ({
  as: 'h2'
}))(() => [tw`block text-red-base`]);
